import APIClient from '@/shared/http/clients/api'

const resourceName = 'matricula'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=id,desc`, config)

/**
 * @name capitalAccount
 * @description Conta Capital
 * @type { Respository }
 */
const capitalAccount = {
  Search
}

export default capitalAccount



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/capitalaccount.js